<template>
  <v-container fill-height align-center justify-center class="plans-view">
    <page-title title="Plans"></page-title>
    <v-progress-circular indeterminate v-if="loading"></v-progress-circular>

    <v-layout v-if="!loading" column align-center justify-center>
      <v-flex class="billing-cycle-switcher">
        <div :class="{ active: cycle === 'MONTHLY' }" class="label">
          Monthly
        </div>
        <v-switch
          v-model="cycle"
          true-value="YEARLY"
          false-value="MONTHLY"
          class="lg-switch"
          :ripple="false"
        ></v-switch>
        <div :class="{ active: cycle === 'YEARLY' }" class="label">
          Yearly (20% Off)
        </div>
      </v-flex>
      <v-flex class="plans">
        <v-card
          flat
          class="plan pa-4"
          v-for="plan in currentPlans"
          :key="plan.id"
        >
          <div class="triangle"></div>
          <v-layout column>
            <v-flex class="plan-details">
              <div class="plan-name">{{ plan.name }}</div>
              <div class="plan-spec">{{ plan.feedback_limit }} feedback responses/month</div>
              <div class="plan-spec">{{ plan.proof_limit }} social proof cards/month</div>
            </v-flex>
            <v-flex class="price-details">
              <div class="price">
                {{ plan.currency.symbol }}{{ price(plan) }}
              </div>
              <div class="price-interval">Per Month</div>
              <div class="price-interval" v-if="cycle==='YEARLY'">*billed yearly</div>
            </v-flex>
            <v-flex class="subscription-actions"
              >
              <v-btn
                color="primaryLight5"
                outline
                small
                depressed
                round
                @click="clickAction(plan)"
                :loading="plan.loading"
              >
                Select
              </v-btn></v-flex
            >

            <!-- <div
              v-if="subscription.plan_id === plan.id"
              class="expiry-info"
              v-html="status(plan).text"
            ></div> -->
          </v-layout>
        </v-card>
      </v-flex>
      <v-layout class="custom-plan">
        <v-flex class="left">
          <div class="custom-text">Custom</div>
          <div class="custom-q">Need more feedback responses or social proofs?</div>
        </v-flex>
        <v-flex class="right"
          ><v-btn color="primaryLight1" large dark depressed>
            Contact us
          </v-btn></v-flex
        >
      </v-layout>
    </v-layout>
    <PaymentScreen
      v-model="paymentScreen"
      :subscription="subscriptionTemp"
      @planUpdateSuccess="planUpdateSuccess"
      @planUpdateFail="planUpdateFail"
    ></PaymentScreen>
    <LgDialog
          v-model="selectClickDialog"
          :title="selectClickDialogMsg.title"
          :content="selectClickDialogMsg.message"
          primary-action-text="OK"
          :titleBg="colors.theme.accent"
          @primaryActionClick="selectClickDialog=false"
          
          
        >
          
          <template v-slot:content>
            <v-container grid-list-md class="mt-2">
              {{selectClickDialogMsg.message}}
               
            </v-container>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            
            <v-btn
              color="accent"
              depressed
              @click="selectClickDialog=false"
            >
              OK
            </v-btn>
          </template>
        </LgDialog>
  </v-container>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'
import format from 'date-fns/format'
import billingApi from '@/api/billing'
import constants from '@/constants'
import PaymentScreen from './PaymentScreen'
import LgDialog from '@/components/LgDialog'

export default {
  name: 'Plans',
  components: { PaymentScreen, LgDialog },
  mounted() {
    this.loadData()
  },
  data() {
    return {
      subscription: null,
      subscriptionTemp: null,
      loading: true,
      paymentScreen: false,
      plans: [],
      cycle: 'YEARLY',
      selectClickDialog: false,
      selectClickDialogMsg: {
        title: '',
        message: ''
      }
    }
  },
  computed: {
    billingCycle() {
      if (!this.subscription) return ''
      if (this.subscription.billing_cycle === 'MONTHLY') {
        return 'Monthly'
      } else {
        return 'Yearly'
      }
    },
    currentPlans(){
      const vm = this
      return this.plans.filter(function(d){
        return vm.cycle === d.billing_cycle
      }).sort(function(a, b){
        return a - b
      })
      
    }
  },
  watch: {
    paymentScreen(newVal, oldVal) {
      if (!this.plans) return
      if (newVal === false)
        each(this.plans, function(d) {
          d.loading = false
        })
    }
  },
  methods: {
    loadData() {
      const vm = this
      vm.loading = true
      Promise.all([
        billingApi
          .subscription(this.$store.getters['user/currentCampaign'].project_id)
          .then(function(res) {
            vm.subscription = res.data.results
          }),
        billingApi
          .plans(this.$store.getters['user/currentCampaign'].project_id)
          .then(function(res) {
            vm.plans = res.data.results.map(function(d) {
              d.loading = false
              return d
            })
          })
      ]).then(function() {
        vm.loading = false
      })
    },
    price(plan) {
      if (!this.subscription) return ''
      if (this.cycle === 'MONTHLY') {
        return plan.data.unit_price
      } else {
        return plan.data.unit_price
      }
    },
    status() {
      const d = { buttonText: 'Select', text: '' }
      if (!this.subscription) return d

      if (this.subscription.plan.id === 'STARTUP') {
        d.buttonText = 'Upgrade plan'
        d.text = `You are on <span class="subscription-status active">free</span> Plan. Enjoy!`
        return d
      }
      if (this.subscription.status === 'TRIAL') {
        if (this.subscription.remaining_trial_days > 0) {
          
          d.text = `You are on
                    <span class="subscription-status active">trial</span> period with
                    <span class="expiry-date">${this.subscription.remaining_trial_days} days left </span>`
          return d
        } else {
          
          d.text = `Your trial plan
                    <span class="subscription-status expired">expired</span> on <span class="expiry-date">${format(
                      new Date(this.subscription.expires_at * 1000),
                      constants.defaultDateFormat
                    )}</span>. Please complete the payment immediately.`
          return d
        }
      } else if (this.subscription.status === 'PENDING') {
        
        d.text = `Payment for this cycle <span class="subscription-status expired">failed</span>.
                    Please complete the payment at the earliest.`
        return d
      } else if (this.subscription.status === 'PAID') {
        
        d.text = `Your subscription is  <span class="subscription-status active">Active</span> and will update on <span class="expiry-date">${format(
          new Date(this.subscription.expires_at * 1000),
          constants.defaultDateFormat
        )}`
        return d
      }
    },
    buttonText(plan) {
      if (plan.id === 'STARTUP') {
        return ''
      }
      if (plan.id === this.subscription.plan_id) {
        if (
          this.subscription.status === 'TRIAL' ||
          this.subscription.status === 'PENDING'
        ) {
          return 'Select'
        }
      } else {
        return 'Select'
      }
    },
    clickAction(plan) {
      if(this.subscription.status === 'PAID' && this.subscription.plan_id === plan.id){
        this.selectClickDialog = true
        this.selectClickDialogMsg.title = 'Subscription'
        this.selectClickDialogMsg.message = 'You are already subscribed to this plan.'
        return
      }
      this.subscriptionTemp = cloneDeep(this.subscription)
      this.subscriptionTemp.billing_cycle = this.cycle
      this.subscriptionTemp.plan_id = plan.id
      this.subscriptionTemp.amount = plan.price
      if(this.cycle === 'YEARLY')
        this.subscriptionTemp.amount = plan.price * 12
      this.paymentScreen = true
      plan.loading = true
    },
    cancelSubscription() {},
    planUpdateSuccess(data){
      console.log('planUpdateSuccess', data)
      this.loading = false
      this.paymentScreen = false
    },
    planUpdateFail(data){
      console.log('planUpdateFail', data)
      this.loading = false
      this.paymentScreen = false
    }
  }
}
</script>

<style lang="stylus">
.plans-view
    .billing-cycle-switcher
        display flex
        align-items center
        justify-content center
        max-height 50px
        margin-bottom 30px
        .lg-switch
            max-width 50px
            .v-input--switch__track
                background-color $color-accent
        .label
            font-size: 14px;
            color: $color-primary-light-1
            margin 0 10px
            &.active
                font-weight 500

    .plans
        display flex
        flex-direction row
        max-height 400px
    .plan
        border 1px solid $color-primary-light-8
        border-radius 5px
        width 250px
        
        margin 10px
        padding-bottom 10px
        &.selected
            border 2px solid $color-accent
            .triangle
                display: block
        .triangle
            width: 0;
            height: 0;
            border-top: 35px solid $color-accent;
            border-right: 35px solid transparent;
            border-radius 0 !important
            position: absolute;
            left: 0;
            top: 0;
            display: none
    .current-plan
        width 460px
        border 1px solid $color-primary-light-8
        box-sizing border-box
        border-radius 5px
    .plan-details
        padding-top 10px
        padding-left 15px
        .plan-name
            font-weight: 600;
            font-size: 18px;
            color: $color-primary;
        .plan-spec
            font-size: 12px
            color: $color-primary-light-1;
    .price-details
        text-align center
        margin-top 40px
        .price
            font-weight: bold;
            font-size: 36px;
            color: $color-accent
        .price-interval
            font-weight: normal
            font-size: 16px
            color: $color-primary-light-5
            text-transform capitalize
    .expiry-info
      font-size: 12px;
      text-align: center;
      color: #fa6b6b;
      line-height: 1.2;
      margin-top: 15px;

    .subscription-actions
        margin-top 35px
        text-align center

    .custom-plan
        width 600px
        max-height 100px
        color $color-primary-light-1
        font-size 18px
        margin-top 30px
        .custom-text
            font-weight bold
        .custom-q
            font-size 18px
</style>
